import api from '@/lib/api'

const state = () => ({
  all: [],
  currentLead: { 
    account: { account_name: '' },
    customer: { name: '' },
    lead_date: Date.now(),
    user: { name: '' },
  },
})

const getters = {
  all:         state => state.all,
  currentLead: state => state.currentLead,
}

const actions = { 
  // eslint-disable-next-line no-empty-pattern
  async createDispute({ }, { lead_id, ...dispute } ) {
    const result = await api.post(`/leads/${ lead_id }/dispute`, dispute)
    if (result.ok) {
      return { ok: true, created: await result.json }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async declineLead({ }, { lead_id, ...params } ) {
    const result = await api.post(`/leads/${ lead_id }/decline`, params)
    if (result.ok) {
      return { ok: true, created: await result.json }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },
  
  async loadAll({ commit }, { period, inProgress=false } = {} ) {
    let params = new URLSearchParams()
    if (period) params.append( 'period', period )
    if (inProgress) params.append( 'inProgress', inProgress)

    const result = await api.get('/leads' +  (params.toString() ? '?' + params : ''))
    if (result.ok) {
      commit('SET_ALL', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrent({ commit }, { lead_id }) {
    const result = await api.get(`/leads/${ lead_id }`)
    if (result.ok) {
      commit('SET_CURRENT', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateCurrent({ commit }, lead ) {
    const result = await api.put(`/leads/${ lead.lead_id }`, { lead: lead })
    if (result.ok) {
      commit('SET_CURRENT', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_ALL(state, leads) {
    state.all = leads
  },

  SET_CURRENT(state, lead) {
    state.currentLead = lead
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}